import React from 'react';

import type { FieldProps } from '@rjsf/utils';

import { Box, Link, Typography } from '@mui/material';

/**
 * Custom RJSF field that renders a read-only linked account as a clickable MUI Link.
 * Pass `creditCustomerId` via `ui:options` to set the href.
 */
export default function LinkedAccountField({ formData, uiSchema, schema }: FieldProps) {
  const creditCustomerId = uiSchema?.['ui:options']?.creditCustomerId as string | undefined;
  const email = formData as string | undefined;

  return (
    <Box>
      <Typography variant="caption" color="text.secondary">
        {schema.title}
      </Typography>
      <Box>
        {creditCustomerId ? (
          <Link href={`/users/${creditCustomerId}`} underline="hover" variant="body1">
            {email || creditCustomerId}
          </Link>
        ) : (
          <Typography variant="body1" color="text.secondary">
            No linked personal account
          </Typography>
        )}
      </Box>
    </Box>
  );
}
